"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTeamQuoteAuthorProperty = exports.teamQuoteAuthorPropertyDefinition = void 0;
exports.teamQuoteAuthorPropertyDefinition = {
    view: {
        label: 'Author',
        hint: 'If you can\'t link the quote to an athlete, add the name of the quote author here.',
    },
    constraints: [],
    type: 'text',
    multiple: false,
    name: 'team-quote-author',
};
const isTeamQuoteAuthorProperty = (prop) => {
    return prop.name === exports.teamQuoteAuthorPropertyDefinition.name;
};
exports.isTeamQuoteAuthorProperty = isTeamQuoteAuthorProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVhbS1xdW90ZS1hdXRob3IucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy90ZWFtLXF1b3RlLWF1dGhvci5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGlDQUFpQyxHQUFHO0lBQy9DLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxRQUFRO1FBQ2YsSUFBSSxFQUFFLG9GQUFvRjtLQUMzRjtJQUNELFdBQVcsRUFBRSxFQUFFO0lBQ2YsSUFBSSxFQUFFLE1BQU07SUFDWixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxtQkFBbUI7Q0FDTSxDQUFBO0FBSTFCLE1BQU0seUJBQXlCLEdBQUcsQ0FBQyxJQUFrQixFQUFtQyxFQUFFO0lBQy9GLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyx5Q0FBaUMsQ0FBQyxJQUFJLENBQUE7QUFDN0QsQ0FBQyxDQUFBO0FBRlksUUFBQSx5QkFBeUIsNkJBRXJDIn0=